module.exports = __webpack_public_path__ + "static/img/login_bg.96a8b6e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login_bg.png
// module id = 1/O3
// module chunks = 67